module.exports = __webpack_public_path__ + "static/media/logo_eBaoCloud-light_blue.fe35cf14.png";